import format from 'date-fns/format/index.js';
import addDays from 'date-fns/fp/addDays/index.js';
import { find, findIndex, go, html, isNil, map, reject, sel, sortBy, strMap, zipWithIndexL } from 'fxjs/es';
import { typoPcMo } from '../../../../../../../services/MarppleShop/shared/typography/typo.js';
import { getAvailableColors, getProductStatus } from '../../../../../../Creator/Setting/S/fs.js';
import { DeliveryTypeS } from '../../../../../../DeliveryType/S/Function/module/DeliveryTypeS.js';
import { GoodsTypeS } from '../../../../../../GoodsType/S/Function/module/GoodsTypeS.js';
import { isNeedPreview } from '../../../../../../Maker/S/categorize.js';
import { PBStoresDeliveryCompanyConstantS } from '../../../../../../PB/StoresDeliveryCompany/S/Constant/module/PBStoresDeliveryCompanyConstantS.js';
import { PriceS } from '../../../../../../Price/S/Function/module/PriceS.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import {
  addAttrIf,
  commify,
  differenceTimeInUnits,
  htmlIf2,
} from '../../../../../../Util/S/Function/util.js';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { isEbookByCateRootCode } from '../../../../../Studio/DigitalProductCreator/S/Function/util.js';
import { MShopUtilConstantS } from '../../../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { MShopAppTokenGateStoresProductTmplS } from '../../../../TokenGate/StoresProduct/S/Tmpl/module/MShopAppTokenGateStoresProductTmplS.js';
import { PRODUCT_STATUS, PRODUCT_STATUS_TEXT } from '../../constant.js';
import { checkIsDisabled, checkProductSaleStatus, getProductSaleStatus } from '../../fs.js';
import { messages } from '../../message_id.js';
import { makePromotionalProductsHtml, makeTShirtsHtml } from './hyundai_n.js';
import { MShopCoreConstantS } from '../../../../../Core/S/Constant/module/MShopCoreConstantS.js';
import { makeMembershipSignupButtonHtml, makeMembershipTagHtml } from './membership.ts';
import { humanReadableNumberV2 } from '../../../../../../../shared/utils/formatter/human-readable-number.formatter.ts';
import { font } from '../../../../../../../services/MarppleShop/shared/typography/index.ts';
import { ButtonFactory } from '../../../../../../../services/MarppleShop/shared/components/atoms/ButtonFactory/ButtonFactory.ts';
import { ButtonFollow } from '@services/MarppleShop/renderApp/components/atoms/ButtonFollow/ButtonFollow.ts';
import { BaseDateButtonAction } from '@services/MarppleShop/shared/components/atoms/ButtonFactory/buttons/index.ts';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';
import { shareIcon } from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';
import {
  makeFormSubmitBtnInfoNess,
  makeFormSubmitBtnNess,
  makeNotiHtmlNess,
  makeProdColorOptionsHtmlNess,
  makeProductInfoHtmlNess,
  makeProductQuantityHtmlNess,
  makeProductSellingTimeHtmlNess,
  makeRadioOptionsNess,
  makeSizeOptionsHtmlNess,
  makeTotalPriceHtmlNess,
} from './productDetailFormNess.js';

const getByLang = (key, obj) => sel(key + _en, obj);

// 상품 기본 정보
export const makeProductInfoHtml = ({
  product_detail,
  store,
  is_seller,
  is_mobile = false,
  need_tilde_currency,
  funding_info,
}) => {
  if (UtilS.isNessApp()) {
    return makeProductInfoHtmlNess({ product_detail, is_seller, is_mobile, need_tilde_currency });
  }

  const {
    _: { base_product, stores_product, selected_option_group },
    is_public,
    is_sticker,
    ['name' + _en]: prod_name,
  } = product_detail;

  const { is_use_creator, is_use_creator_en, is_use_creator_jp } = base_product;
  const name_creator = base_product['name_creator' + G._en];
  const base_name = name_creator?.length ? name_creator : base_product['name' + G._en];
  const {
    is_prohibited,
    is_confirmed,
    is_confirm_req,
    is_check_design,
    goods_type_id,
    _: { digital_product, cate_root },
  } = stores_product;

  const product_status = getProductStatus({
    is_prohibited,
    is_public,
    is_confirmed,
    is_confirm_req,
    is_digital_product: !!digital_product?.id,
    is_check_design,
    is_use_creator,
    is_use_creator_en,
    is_use_creator_jp,
  });

  const status_text = [PRODUCT_STATUS.PUBLIC].includes(product_status)
    ? ''
    : `(${T(PRODUCT_STATUS_TEXT[product_status])})`;

  const creator_price = creatorPriceOfProduct(product_detail);
  const selected_opt_name = selected_option_group ? selected_option_group['title' + _en] : '';
  const bp_name = base_name + (is_sticker && selected_opt_name ? ` - ${selected_opt_name}` : '');

  return html`
    <div class="pd-product">
      ${htmlIf2(product_detail.membership_info?.is_membership && is_mobile, () =>
        makeMembershipTagHtml(store.name, product_detail.membership_info.memberships, is_mobile),
      )}

      <!-- 상품 상세 타이틀 영역 -->
      <div class="pd-product__title">
        <!-- 상품 상세 타이틀 컨텐츠 영역 -->
        <div class="pd-product__title_area">
          ${is_seller && GoodsTypeS.isMps(goods_type_id)
            ? html`<h2 class="pd-product__name">[샘플주문]</h2>`
            : ''}
          <!-- 상품 상세 타이틀 컨텐츠 상품명 영역 -->
          <h2 class="pd-product__name pd-product__name--${T.lang}">
            ${status_text ? `<span class='pd-product__status'>${status_text}</span>` : ''}
            ${prod_name || bp_name}
          </h2>
          ${htmlIf2(
            isEbookByCateRootCode(cate_root.code),
            () => html`
              <div
                class="pd-product__ebook-writer ${typoPcMo({
                  is_mobile,
                  pc: '20_medium',
                  mo: '16_medium',
                })}"
              >
                ${digital_product._.ebook_info.writer}
              </div>
            `,
          )}
          ${UtilS.htmlIf(
            GoodsTypeS.isMps(goods_type_id),
            html`<p class="pd-product__bp-name">${bp_name}</p>`,
          )}
        </div>
      </div>

      ${UtilS.htmlIf2(
        isNil(funding_info),
        // 상품 상세 가격/배송 안내 버튼 영역
        () => html`
          <div class="pd-product__price-delivery-info">
            <!-- 상품 상세 가격 영역 -->
            <p class="pd-product__price">
              <input type="hidden" name="price" value="${creator_price}" />
              <span class="pd-product__price mp_currency ${MShopUtilConstantS.UNICA_KLASS}">
                ${UtilS.commify(creator_price)}
              </span>
            </p>

            <!-- 상품 상세 배송 안내 버튼 영역 -->
            ${makeProdDeliveryHtml(goods_type_id)}
          </div>
        `,
        // 펀딩 소제목
        () => html`
          <div class="pd-product__funding">
            <input type="hidden" name="price" value="${creator_price}" />
            <p class="pd-product__funding-description ${font('14_medium', '12_medium')}">
              ${funding_info.description}
            </p>
          </div>
        `,
      )}
    </div>
  `;
};

export const makeProdActionHtml = ({ product_detail }) => {
  return html`
    <div class="pd-product__action">
      <!-- 공유버튼 -->
      <div class="pd-product__action--btn">${makeProdShareHtml()}</div>

      <div class="pd-product__action--divider"></div>

      <!-- 좋아요 버튼 -->
      <div class="pd-product__action--btn">${makeProdLikeHtml({ product_detail })}</div>
    </div>
  `;
};

// share 버튼
export const makeProdShareHtml = (is_hidden) => {
  if (is_hidden) {
    return '';
  }

  return html`
    <button type="button" class="pd__action-btn share pd-product__share-btn">
      ${shareIcon({ html })}<span class="${font('14_medium', '12_medium')}"
        >${ET('mps2::funding::card::share')}</span
      >
    </button>
  `;
};

// 좋아요 버튼
export const makeProdLikeHtml = ({ product_detail, is_mobile_bottom }) => {
  const {
    _: { stores_products_like },
    id: stores_product_id,
  } = sel('_.stores_product', product_detail);
  const already_like = !!stores_products_like?.id;
  const { value, unit } = humanReadableNumberV2.to(
    product_detail._.stores_product.like_count,
    ET.lang === 'kr',
  );

  return html`
    <div class="pd-product__like ${already_like ? 'pd-product__like--active' : ''}">
      <button
        type="button"
        class="pd__action-btn like ${already_like ? 'active' : ''}"
        data-stores_product_id="${stores_product_id}"
      >
        ${UtilS.htmlIf2(is_mobile_bottom, MShopCoreTmplS.myFanIcon, MShopCoreTmplS.heartIconV2)}
      </button>
      <span class="pd-product__like--text ${font('14_medium', '12_medium')}"
        >${ET('mps2::mypage::like::title')}</span
      >
      <span class="pd-product__like-count  ${font('14_medium', '12_medium')}">${value}${unit}</span>
    </div>
  `;
};

// delivery 버튼
export const makeProdDeliveryHtml = (goods_type_id) => {
  const goods_type_delivery = {
    MPS: ET('goods_types::mps_delivery'),
    PBG: ET('goods_types::pbg_delivery'),
    TPL: ET('goods_types::tpl_delivery'),
    DTG: null,
  }[goods_type_id];

  return UtilS.htmlIf(
    goods_type_delivery,
    html`
      <button type="button" class="pd-product__delivery-btn tooltip-icon">
        <i class="pd-product__delivery-btn__icon">${MShopCoreTmplS.deliveryIcon()}</i>
        <a class="pd-product__delivery-btn__txt ${font('14_medium')}">${goods_type_delivery}</a>
      </button>
      ${makeProdDeliveryTooltipHtml(goods_type_id)}
    `,
  );
};

export const makeProdDeliveryTooltipHtml = (goods_type_id) => {
  const TOOLTIP_TITLE_MAP = {
    MPS: ET('goods_types::tooltip::mps_title'),
    PBG: ET('goods_types::tooltip::pbg_title'),
    TPL: ET('goods_types::tooltip::tpl_title'),
    DTG: null,
  };

  const TOOLTIP_DESCRIPTION_MAP = {
    MPS: ET('goods_types::tooltip::mps_description'),
    PBG: ET('goods_types::tooltip::pbg_description'),
    TPL: ET('goods_types::tooltip::tpl_description'),
    DTG: null,
  };

  return html`
    <div class="tooltip-container mps2-tooltip" role="tooltip">
      <h4>${TOOLTIP_TITLE_MAP[goods_type_id]}</h4>
      <p>${TOOLTIP_DESCRIPTION_MAP[goods_type_id]}</p>
    </div>
  `;
};

// 라디오 타입 옵션
export const makeRadioOptions = ({ name, type = 'value', options, disabled, is_mobile }) => {
  if (UtilS.isNessApp()) {
    return makeRadioOptionsNess({ name, type, options });
  }

  const getStyle = () => {
    return `style="border-color: ${MShopCoreConstantS.colors.blue}"`;
  };
  const checkColorChip = (index) => {
    const is_max = is_mobile ? 15 : 19;
    const is_display_none = is_mobile ? 13 : 17;
    return type === 'color' && options?.length >= is_max && index >= is_display_none ? `pd-color-chip` : '';
  };
  const checkDisabled = (item) => (item.disabled ? 'disabled' : '');
  const getFaceContent = (item) =>
    (type == 'preview' &&
      `<img src="${item.preview}" alt="${item.label}" class="pd-radio__face--preview" />`) ||
    (type == 'color' &&
      `<span style="background: ${
        item.color2
          ? `linear-gradient(135deg, ${
              item.color == '#ffffff' || item.color == '#fefefe' ? '#f8f8f8' : item.color
            } 50%, ${item.color2 == '#ffffff' || item.color2 == '#fefefe' ? '#f8f8f8' : item.color2} 50%)`
          : item.color
      }" class="pd-radio__face--color"></span>`) ||
    `<span class="pd-radio__face--value">${item.name}</span>`;

  const formatSignedNumber = (value) => {
    const matched = value.match(/^([+-]?)(\d+)$/);
    if (!matched) return value;

    const [, sign, number] = matched;
    const formatted = Number(number).toLocaleString();
    return `${sign}${formatted}`;
  };

  return html`
    <div class="pd-radio-group ${type}">
      ${go(
        options,
        zipWithIndexL,
        strMap(([index, item]) => {
          return item.is_public
            ? html`
                <label
                  class="pd-radio ${type} ${checkDisabled(item)} ${checkColorChip(index)}"
                  ${getStyle(index)}
                >
                  <input
                    type="radio"
                    name="${name}"
                    ${disabled ? 'disabled' : ''}
                    ${checkDisabled(item)}
                    ${item.is_active ? 'checked' : ''}
                    data-price="${item.price || 0}"
                    value="${item.value}"
                  />
                  <span class="pd-radio__face ${type} ${checkDisabled(item)}" title="${item.label}">
                    ${UtilS.htmlIf2(
                      type === 'color',
                      () => html`
                        <span class="pd-radio__face--active--icon" data-is-active="${Boolean(item.is_active)}"
                          >${MShopCoreTmplS.checkIconV1()}</span
                        >
                      `,
                    )}
                    ${getFaceContent(item)}
                  </span>
                  ${UtilS.htmlIf(
                    type !== 'color',
                    html`<span class="pd-radio__text" title="${item.label}"
                      >${formatSignedNumber(item.label)}</span
                    >`,
                  )}
                </label>
              `
            : '';
        }),
      )}
      ${type === 'color'
        ? html`
            <button type="button" class="expand-btn pd-radio" ${disabled ? 'disabled' : ''}>
              <span class="pd-radio__face">
                <span class="pd-radio__face--color">
                  <i class="pd-radio__face--icon">${MShopCoreTmplS.newPlusIcon()}</i>
                </span>
              </span>
            </button>
          `
        : ''}
    </div>
  `;
};

// 셀렉트 타입 옵션
export const makeSelectOptions = (type, options, disabled) => {
  return html`
    <select name="${type}" class="pd-select" ${disabled ? 'disabled' : ''}>
      ${type == 'device'
        ? html`<option value="">${ET('mps2::product_detail::select_phonecase')}</option>`
        : ''}
      ${strMap(
        (opt) => html`
          <option value="${opt.value}" ${type == 'device' ? '' : addAttrIf(opt.selected, 'selected')}>
            ${opt.label}
          </option>
        `,
        options,
      )}
    </select>
  `;
};

// 색상 옵션
export const makeProdColorOptionsHtml = ({ product_detail, selected_bpc, is_mobile }) => {
  if (UtilS.isNessApp()) {
    return makeProdColorOptionsHtmlNess({ product_detail, selected_bpc });
  }

  const base_product = sel('_.base_product', product_detail);
  const base_product_colors = sel('_.base_product._.base_product_colors', product_detail);
  const store_product_colors = sel('_.stores_product._.store_product_colors', product_detail);
  const selected_bpc_id = selected_bpc?.id;
  const colors = getAvailableColors(base_product_colors, store_product_colors);
  const options = go(
    colors,
    map((item) => ({
      value: item.id,
      label: item['name' + _en],
      color: item.color_code,
      color2: item.color_code2,
      is_public: item.is_public,
      is_active: item.id === selected_bpc_id,
    })),
    sortBy((item) => !item.is_active),
  );

  const selected_color = options.find((option) => option.is_active);
  const use_label = isNeedPreview(base_product);
  const option_label = use_label ? messages.preview_by_device : messages.color;
  const max_count = is_mobile ? 8 : 16;

  return html`
    <div class="pd-field colors ${colors.length > max_count ? 'fold' : ''}">
      <div class="pd-field__label">
        <span>${T(option_label)}</span>
        ${UtilS.htmlIf2(
          selected_color,
          () =>
            html`<span class="pd-field__label-name-txt ${font('14_medium')}">${selected_color.label}</span>`,
        )}
      </div>
      <div class="dynamic-html">
        ${makeRadioOptions({ name: 'color', type: 'color', options, is_mobile })}
      </div>
    </div>
  `;
};

// 사이즈 선택 버튼
export const makeSizeOptionsHtml = ({ use_size_option, selected_bpc, disabled, is_multi_option }) => {
  if (UtilS.isNessApp()) {
    return makeSizeOptionsHtmlNess({ use_size_option, selected_bpc });
  }

  if (!use_size_option) return '';

  const { base_product_sizes2, select_size_id = '' } = sel('_', selected_bpc) || {};

  const options = map((item) => {
    const price = getByLang('price', item);
    const label = item._is_not_stock
      ? T(messages.sold_out)
      : PriceS.price(price)
        ? `+${PriceS.price(getByLang('price', item))}`
        : '';
    return {
      label,
      value: item.id,
      name: getByLang('name', item),
      price: getByLang('price', item),
      disabled: item._is_not_stock,
      is_public: item.is_public,
      is_active: is_multi_option ? false : select_size_id == item.id, // 멀티 옵션인 경우 active 처리 하지 않는다.
    };
  }, base_product_sizes2);

  if (!find((opt) => opt.is_active, options)) {
    const index = findIndex((opt) => !opt.disabled, options);
    if (options[index] && !is_multi_option) options[index].is_active = true; // 멀티 옵션인 경우 active 처리 하지 않는다.
  }

  if (UtilS.isNessApp()) {
    return html`
      <div class="pd-field size">
        <div class="pd-field__label">${ET('product_detail::options::size')}</div>
        <div>
          <div class="dynamic-html">${makeRadioOptions({ name: 'size', options })}</div>
          ${UtilS.htmlIf2(use_size_option, makeSizeGuideHtml)}
        </div>
      </div>
    `;
  }

  return html`
    <div class="pd-field size">
      <div class="pd-field__label">
        <span class="${font('14_bold')}">${T(messages.size)}</span>
      </div>
      <div>
        <div class="dynamic-html">${makeRadioOptions({ name: 'size', options, disabled })}</div>
      </div>
    </div>
  `;
};

// 디바이스 선택
export const makeDeviceSelectorHtml = (devices, default_id) => {
  const select_options = go(
    devices,
    reject(({ is_composite_publish }) => is_composite_publish),
    map((item) => ({
      label: item.name,
      value: item.id,
      thumb: item.model_thumb_url,
      selected: item.id === default_id,
    })),
  );

  return html`
    <div class="pd-field">
      <div class="pd-field__label">${T(messages.device)}</div>
      ${makeSelectOptions('device', select_options)}
    </div>
  `;
};

// 사이즈 가이드
export const makeSizeGuideHtml = () => {
  const is_ness = UtilS.isNessApp();
  return html`
    <div class="pd-guide ruler">
      <span class="pd-guide__icon">${MShopUtilConstantS.svg.ruler}</span>
      <a class="pd-guide__text toggle-size-modal">${T(messages.check_size_guide)}</a>
      ${UtilS.htmlIf2(
        !is_ness,
        () => html`<a class="pd-guide__anchor toggle-size-modal">${MShopUtilConstantS.svg.arrow_right}</a>`,
      )}
    </div>
  `;
};

// 현대 주문 가이드
export const makeOrderGuideHtml = ({ product_detail }) => {
  const now = Date.now();
  const { shipping_date_hidden } = sel('_.stores_product', product_detail);

  const deliver_date = go(now, UtilS.getSalesPeriodOf, sel('sell_end_at'), addDays(3));
  const deliver_until_date = addDays(7)(deliver_date);

  if (shipping_date_hidden) return '';

  return html`
    <div class="pd-guide">
      <span class="pd-guide__icon">${MShopUtilConstantS.svg.box}</span>
      <span class="pd-guide__text">
        ${T(messages.expect, {
          start: format(deliver_date, 'M/d'),
          end: format(deliver_until_date, 'M/d'),
        })}
      </span>
    </div>
  `;
};

// 타이머
export const makeProductSellingTimeHtml = ({ day, hour, minute, second }) => {
  if (UtilS.isNessApp()) {
    return makeProductSellingTimeHtmlNess({ day, hour, minute, second });
  }

  const _day = Math.max(0, day);
  const _hour = String(Math.max(0, hour)).padStart(2, '0');
  const _minute = String(Math.max(0, minute)).padStart(2, '0');
  const _second = String(Math.max(0, second)).padStart(2, '0');
  return `${_day ? _day + 'D ' : ''}${_hour}:${_minute}:${_second}`;
};

export const makePossibleQuantityHtml = (max_purchase_per_user, possible_quantity) => {
  if (!max_purchase_per_user) return '';
  let text = max_purchase_per_user
    ? ET('product_detail::max_purchase_per_user', { count: max_purchase_per_user })
    : '';

  if (possible_quantity <= 0) {
    text += `<br/>${ET('product_detail::already_possible_quantity')}`;
  } else if (max_purchase_per_user !== possible_quantity) {
    text += `<br/>${ET('product_detail::possible_quantity', { count: possible_quantity })}`;
  }

  return html`
    <div class="pd-field__max_count">
      <div class="pd-field__max_count_icon">${MShopCoreTmplS.boxIcon()}</div>
      <div class="pd-field__max_count_text">${text}</div>
    </div>
  `;
};

export const makeTotalPriceInMobileFormHtml = (
  { count = 1, product_detail, is_dtg },
  { possible_quantity, max_purchase_per_user, is_hide, is_multi_option = false },
) => {
  const tot_price =
    count * creatorPriceOfProduct(product_detail, 1, product_detail.selected_base_product_size_id);

  if (is_multi_option && (!max_purchase_per_user || is_dtg)) {
    return '';
  }

  return html`
    <div class="pd-field direction-column">
      ${UtilS.htmlIf2(
        !is_multi_option,
        () => html`
          <div class="pd-field__count-price ">
            ${is_dtg
              ? html` <input type="hidden" name="quantity" readonly value="1" /> `
              : html`
                  <div class="pd-field__row pd-field__pd-counter-wrap ${is_hide ? 'hide' : ''}">
                    <div class="pd-field__label">${T(messages.quantity)}</div>
                    <div class="pd-counter ${is_hide ? 'disabled' : ''}">
                      <button type="button" class="pd-counter__btn down" disabled>
                        ${MShopCoreTmplS.minusIcon()}
                      </button>
                      <input
                        type="text"
                        name="quantity"
                        readonly
                        class="pd-counter__current"
                        value="${count}"
                        ${is_hide ? 'disabled' : ''}
                      />
                      <button
                        type="button"
                        class="pd-counter__btn up"
                        ${is_hide || possible_quantity <= 1 ? 'disabled' : ''}
                      >
                        ${MShopCoreTmplS.plusIcon()}
                      </button>
                    </div>
                  </div>
                `}
            <div class="pd-total ${is_dtg || is_hide ? 'hide' : ''}  pd-field__row">
              <div class="pd-total__count">${T('order::총 상품 금액')}</div>
              <div class="pd-total__price mp_currency">${UtilS.commify(tot_price)}</div>
            </div>
          </div>
        `,
      )}
      <!-- 구매 가능 수량 안내 -->
      ${UtilS.htmlIf2(max_purchase_per_user && !is_dtg, () =>
        makePossibleQuantityHtml(max_purchase_per_user, possible_quantity),
      )}
    </div>
  `;
};

// 총 수량 및 금액
export const makeTotalPriceHtml = (
  { count = 1, product_detail, is_dtg },
  {
    disabled,
    possible_quantity,
    max_purchase_per_user,
    is_hide,
    is_multi_option = false,
    need_tilde_currency,
  } = {},
) => {
  if (UtilS.isNessApp()) {
    return makeTotalPriceHtmlNess({ count, product_detail, need_tilde_currency });
  }

  const tot_price =
    count * creatorPriceOfProduct(product_detail, 1, product_detail.selected_base_product_size_id);

  if (is_multi_option && (!max_purchase_per_user || is_dtg)) {
    return '';
  }

  return html`
    <div class="pd-field">
      <!-- multi option이 불가한 경우에만 기존 price html을 그린다. -->
      <!-- is_multi_option = true인 경우엔 price를 multi option과 함께 프론트에서 그려준다. -->
      ${UtilS.htmlIf2(!is_multi_option, () => {
        const commified_price = UtilS.commify(!disabled ? tot_price : 0);
        return html`
          <div class="pd-field__count-price ${is_hide ? 'hide' : ''}">
            <div class="pd-field__label count_label">${T(messages.quantity)}</div>
            ${is_dtg
              ? html`<input type="hidden" name="quantity" readonly value="1" />`
              : html`
                  <div class="pd-field__pd-counter-wrap">
                    <div class="pd-counter ${disabled || is_hide ? 'disabled' : ''}">
                      <button type="button" class="pd-counter__btn down" disabled>
                        ${MShopCoreTmplS.minusIcon()}
                      </button>
                      <input
                        type="text"
                        name="quantity"
                        readonly
                        class="pd-counter__current"
                        value="${count}"
                        ${disabled || is_hide ? 'disabled' : ''}
                      />
                      <button
                        type="button"
                        class="pd-counter__btn up"
                        ${disabled || is_hide || possible_quantity <= 1 ? 'disabled' : ''}
                      >
                        ${MShopCoreTmplS.plusIcon()}
                      </button>
                    </div>
                    <div class="pd-total ${is_dtg || is_hide ? 'hide' : ''}">
                      <div class="pd-total__count">${ET('product_detail::total_price')}</div>
                      <div class="pd-total__price mp_currency ${font('24_bold')}">${commified_price}</div>
                    </div>
                  </div>
                `}
          </div>
        `;
      })}
      ${UtilS.htmlIf2(max_purchase_per_user && !is_dtg, () =>
        makePossibleQuantityHtml(max_purchase_per_user, possible_quantity),
      )}
    </div>
  `;
};

export const makeHyundaiNPackageHtml = ({ hyundai_n_products }) => {
  const { t_shirt_product, promotional_products } = hyundai_n_products;

  return html`
    <div class="pd-package">
      <div id="t_shirt_proeduct">${makeTShirtsHtml(t_shirt_product)}</div>
      <div id="promotional_products">${makePromotionalProductsHtml(promotional_products)}</div>
    </div>
  `;
};

export const makeCounterHtml = (init_count = 1, is_hide) => {
  return html`
    <div class="pd-field counter" ${is_hide ? 'style="display:none;"' : ''}>
      <div class="pd-field__label">${T(messages.quantity)}</div>
      <div class="pd-counter">
        <button type="button" class="pd-counter__btn down">${MShopUtilConstantS.svg.minus}</button>
        <input type="text" name="quantity" readonly class="pd-counter__current" value="${init_count}" />
        <button type="button" class="pd-counter__btn up">${MShopUtilConstantS.svg.plus}</button>
      </div>
    </div>
  `;
};

const makeMaxPurchaseMore = ({ max_purchase_per_user, possible_quantity }) => {
  if (max_purchase_per_user == possible_quantity) {
    return '';
  } else if (possible_quantity > 0) {
    return T(messages.possible_quantity, { possible_quantity });
  } else {
    return T(messages.already_possible_quantity);
  }
};

// 구매 수량 제한 (1인당) 인풋
const makeMaxPurchaseCounterHtml = (possible_quantity, max_purchase_per_user, is_hide) => {
  const is_ness = UtilS.isNessApp();
  return html`
    <div class="pd__quantity">
      <div class="pd-field counter" ${is_hide ? 'style="display:none;"' : ''}>
        <div class="pd-field__label">${T(messages.quantity)}</div>
        <div class="pd-counter${possible_quantity > 0 ? '' : ' pd-counter--none'}">
          <button type="button" class="pd-counter__btn down" disabled>${MShopUtilConstantS.svg.minus}</button>
          <input type="text" name="quantity" readonly class="pd-counter__current" value="${1}" />
          <button type="button" class="pd-counter__btn up">${MShopUtilConstantS.svg.plus}</button>
        </div>
      </div>

      <div class="pd__max-purchase-per-user" ${is_hide ? 'style="display:none;"' : ''}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Component 2">
            <g id="Group 1474">
              <rect id="Rectangle 440" x="4" y="6" width="12" height="11" rx="1.5" stroke="#F0415A" />
              <path
                id="Rectangle 441"
                d="M12.75 8.5V5.25C12.75 3.73122 11.5188 2.5 10 2.5V2.5C8.48122 2.5 7.25 3.73122 7.25 5.25V8.5"
                stroke="#F0415A"
                stroke-linecap="round"
              />
            </g>
          </g>
        </svg>
        ${T(messages.max_purchase_per_user, { max_purchase_per_user })}
        ${UtilS.htmlIf2(
          !is_ness,
          () => html` <div>${makeMaxPurchaseMore({ max_purchase_per_user, possible_quantity })}</div>`,
        )}
      </div>
    </div>
  `;
};

// 안쓰이면 지우자
export const makeProductQuantityHtml = (possible_quantity, max_purchase_per_user, is_hide) => {
  if (UtilS.isNessApp()) {
    return makeProductQuantityHtmlNess(possible_quantity, max_purchase_per_user, is_hide);
  }
  return max_purchase_per_user
    ? makeMaxPurchaseCounterHtml(possible_quantity, max_purchase_per_user, is_hide)
    : makeCounterHtml(1, is_hide);
};

export const makeNotiHtml = (props) => {
  if (UtilS.isNessApp()) {
    return makeNotiHtmlNess(props);
  }

  /* 여기부터 마플샵 */
  /**
   * @mps-only
   */
  const { product_detail, product_sale_status } = props;
  const {
    _: { stores_product },
    mpsProductDetail,
  } = product_detail;
  const { sell_start_at, sell_end_at } = stores_product;
  const { status, is_show_limited_quantity } = product_sale_status;
  const is_start_selling = +new Date() > +new Date(sell_start_at);

  const makeNotiCommonHtml = (content = () => html``) => html`
    <div class="pd-noti-container">
      <div class="pd-noti-container__triangle">${MShopCoreTmplS.bubbleTriangleIcon()}</div>
      <div class="pd-noti">${content()}</div>
    </div>
  `;

  const now = `${new Date()}`;

  if (!isNil(product_detail.funding)) return '';

  if (status === 'LIMITED_TIME') {
    const [days, hours, minutes, seconds] = BaseDateButtonAction.diff(`${sell_end_at}`, now);
    return makeNotiCommonHtml(
      () => html`
        <div class="pd-noti__label period" data-item_name="period_limit">
          ${MShopCoreTmplS.clockIcon()}
          <div class="remain_time" data-is-limited data-end="${sell_end_at}" data-start="${now}">
            ${preventEscape(BaseDateButtonAction.convertLabel({ days, hours, minutes, seconds }))}
          </div>
        </div>
      `,
    );
  } else if (status === 'COMING_SOON') {
    const [days, hours, minutes, seconds] = BaseDateButtonAction.diff(
      is_start_selling ? `${sell_end_at}` : `${sell_start_at}`,
      now,
    );
    return makeNotiCommonHtml(
      () => html`
        <div class="pd-noti__label period" data-item_name="period_limit">
          ${MShopCoreTmplS.clockIcon()}
          <div
            class="remain_time"
            data-is-limited
            data-end="${is_start_selling ? `${sell_end_at}` : `${sell_start_at}`}"
            data-start="${now}"
          >
            ${preventEscape(
              BaseDateButtonAction.convertLabel(
                { days, hours, minutes, seconds },
                { i18n: 'remain_time_coming_soon' },
              ),
            )}
          </div>
        </div>
      `,
    );
  } else if (status === 'LIMITED_QUANTITY' && is_show_limited_quantity) {
    return makeNotiCommonHtml(
      () => html`
        <div class="pd-noti__label quantity" data-item_name="quantity_limit">
          <div>
            ${ET('product_detail::left_count', { count: commify(mpsProductDetail.stock.availableStock) })}
          </div>
        </div>
      `,
    );
  }

  return '';
};

export const makeFormSubmitBtnInfo = ({
  can_selling,
  sales_info,
  is_digital_product,
  isApp,
  product_status,
  is_purchased_dtg,
  is_sold_out_all_size,
}) => {
  if (UtilS.isNessApp()) {
    return makeFormSubmitBtnInfoNess({
      can_selling,
      sales_info,
      is_digital_product,
      isApp,
      product_status,
      is_purchased_dtg,
    });
  }

  const { is_before_sale, is_after_sale, is_sold_out, is_selling_product } = sales_info;
  const is_disabled =
    !can_selling || // 스토어의 판매상태
    is_sold_out || // 스토어 오너가 아니고, 솔드아웃인 경우
    !is_selling_product || // 스토어 오너가 아니고, 판매중이 아닌경우
    (isApp && is_digital_product) || // 디지털 상품이고, 환경이 앱인경우
    (is_digital_product && ![PRODUCT_STATUS.PUBLIC].includes(product_status)) || // 디지털상품이고, 상품의 상태가 공개중이 아닌경우
    (is_digital_product && is_purchased_dtg) || // 디지털 상품이고 구매하고 7일이 지나지 않은 경우
    is_sold_out_all_size; // 상품의 모든 사이즈가 품절인 경우

  return go(
    void 0,
    () => {
      if (!can_selling) return ET('product_detail::cta::not_approve');
      else if (is_sold_out) return ET('product_detail::cta::sold_out');
      else if (is_before_sale) return ET('product_detail::cta::coming_soon');
      else if (is_after_sale) return ET('product_detail::cta::end_sale');
      else if (isApp && is_digital_product) return ET('product_detail::cta::only_pc');
      else if (is_digital_product && is_purchased_dtg) return ET('product_detail::cta::purchased_dtg');
      else if (is_sold_out_all_size) return ET('cta::sold_out');
      return ET('product_detail::cta::cart');
    },
    (btn_text) => {
      return {
        is_disabled,
        btn_text,
      };
    },
  );
};

const makeSubmitButton = ({ product_detail, submit_btn_text, product_sale_status, is_mobile }) => {
  const {
    _: { stores_product },
  } = product_detail;
  const { sell_start_at, sell_end_at } = stores_product;
  const { status } = product_sale_status;
  const is_start_selling = +new Date() > +new Date(sell_start_at);
  const klass = `pd-submit__btn pd-submit__btn--form`;
  const attr = is_mobile
    ? undefined
    : {
        [`data-action`]: 'checkout',
      };
  const now = `${new Date()}`;

  const makeSubmitButtonText = () => {
    const is_funding = !isNil(product_detail.funding);
    if (is_funding) return ET('preorder::cta_participate_in_the_challenge');
    return ET('product_detail::cta::buy_now');
  };

  switch (status) {
    case 'COMING_SOON': {
      return ButtonFactory.create(status, {
        end: is_start_selling ? `${sell_end_at}` : `${sell_start_at}`,
        start: now,
        is_lazy_timer: true,
        klass,
        size: 'large',
        attr: {
          ...attr,
          disabled: 'true',
        },
      }).toHtmlSSR();
    }
    case 'LIMITED_TIME': {
      return html`
        <div class="pd-submit__btns__wrapper">
          ${makeNotiHtml({ product_detail, product_sale_status })}
          ${ButtonFactory.create('LIMITED_TIME', {
            label: makeSubmitButtonText(),
            end: now,
            start: now,
            is_lazy_timer: true,
            klass,
            attr,
            size: 'large',
          }).toHtmlSSR()}
        </div>
      `;
    }
    case 'LIMITED_QUANTITY':
      return html`
        <div class="pd-submit__btns__wrapper">
          ${makeNotiHtml({ product_detail, product_sale_status })}
          ${ButtonFactory.create('LIMITED_QUANTITY', {
            label: makeSubmitButtonText(),
            quantity: 0,
            show_quantity_limit: false,
            klass,
            attr,
            size: 'large',
          }).toHtmlSSR()}
        </div>
      `;
    case 'SOLD_OUT':
      return ButtonFactory.create(status, {
        label: submit_btn_text,
        klass,
        size: 'large',
        attr: {
          ...attr,
          disabled: 'true',
        },
      }).toHtmlSSR();
    case 'ALWAYS':
    default:
      return ButtonFactory.create(status, {
        label: makeSubmitButtonText(),
        klass,
        attr,
        size: 'large',
      }).toHtmlSSR();
  }
};

const makeCartButton = ({ product_detail, product_sale_status, submit_btn_text }) => {
  const { status, is_disabled } = product_sale_status;
  const {
    _: { stores_product },
  } = product_detail;
  const { sell_start_at, sell_end_at } = stores_product;
  const is_start_selling = +new Date() > +new Date(sell_start_at);
  const klass = `pd-submit__btn pd-submit__btn--cart ${font('16_bold')}`;

  if (is_disabled && status === 'COMING_SOON') {
    const now = `${new Date()}`;

    return ButtonFactory.create(status, {
      end: is_start_selling ? `${sell_end_at}` : `${sell_start_at}`,
      start: now,
      is_lazy_timer: true,
      klass,
      size: 'large',
      attr: {
        disabled: 'true',
      },
    }).toHtmlSSR();
  } else if (!is_disabled)
    return ButtonFactory.create('OUTLINE', {
      label: submit_btn_text,
      klass,
      size: 'large',
      attr: {
        [`data-action`]: 'cart',
      },
    }).toHtmlSSR();

  return ButtonFactory.create('SOLD_OUT', {
    label: submit_btn_text,
    klass,
    size: 'large',
    attr: {
      disabled: 'true',
    },
  }).toHtmlSSR();
};

const makeSubmitButtonText = ({ product_detail, status, btn_text }) => {
  if (status === 'COMING_SOON') {
    const {
      _: {
        stores_product: { sell_start_at, sell_end_at },
      },
    } = product_detail;
    const is_start_selling = +new Date() > +new Date(sell_start_at);
    const remain_time_infos = differenceTimeInUnits(
      ['day', 'hour', 'minute', 'second', 'millisecond'],
      is_start_selling ? new Date(sell_end_at) : new Date(sell_start_at),
      new Date(),
      true,
    );
    return html`
      <div
        class="pd-noti text"
        data-start-at="${sell_start_at}"
        data-end-at="${sell_end_at}"
        data-current="period"
      >
        <div class="pd-noti__label period" data-item_name="period_limit">
          ${MShopCoreTmplS.rocketIcon()}
          <div class="remain_time">
            ${ET('product_detail::coming_soon', {
              time: makeProductSellingTimeHtml(remain_time_infos),
            })}
          </div>
        </div>
      </div>
    `;
  } else {
    return btn_text;
  }
};

const pcSubmit = ({ props, btn_text, status, disabled, is_only_buy_now, is_mobile, product_sale_status }) => {
  /* 여기부터 마플샵 */
  const { product_detail, store } = props;

  const submit_btn_text = makeSubmitButtonText({ product_detail, btn_text, status });
  const submit_btn = makeSubmitButton({
    product_detail,
    submit_btn_text,
    product_sale_status,
    is_mobile,
  });
  const cart_btn = makeCartButton({ product_detail, submit_btn_text, product_sale_status });

  return html`
    ${htmlIf2(product_detail.membership_info?.is_membership, () =>
      makeMembershipTagHtml(store.name, product_detail.membership_info.memberships, is_mobile),
    )}
    <div class="pd-submit">
      ${htmlIf2(
        !disabled && product_detail.membership_info?.need_signup_membership,
        () => makeMembershipSignupButtonHtml(store.domain_name),
        () => html`
          <div class="pd-submit__btns">
            ${
              /* 강제 무료배송 상품일 경우 */
              is_only_buy_now ? '' : cart_btn
            }
            ${UtilS.htmlIf2(is_only_buy_now || !disabled, () => submit_btn)}
          </div>
        `,
      )}
    </div>
  `;
};

export const submitDisabledBtn = (btn_text) => {
  return html` <button class="pd-submit__btn" disabled type="button">${btn_text}</button>`;
};

const mobileSubmit = ({
  props,
  props: { product_detail },
  btn_text,
  status,
  disabled,
  is_only_buy_now,
  isApp,
  is_login,
  product_sale_status,
}) => {
  const { store, creator_summary } = props;
  const submit_btn_text = makeSubmitButtonText({ product_detail, btn_text, status });
  const submit_btn = makeSubmitButton({
    product_detail,
    submit_btn_text,
    product_sale_status,
    is_mobile: true,
  });

  return html` <div class="pd-submit">
    <div class="pd-submit__action">
      ${new ButtonFollow({
        store_id: creator_summary.id,
        is_follow: creator_summary.is_liked,
        is_login,
        klass: 'pd-submit__btn--become--fan',
        withLabel: true,
      }).toHtmlSSR()}
    </div>
    ${UtilS.htmlIf2(
      !disabled && product_detail.membership_info?.need_signup_membership,
      () => makeMembershipSignupButtonHtml(store.domain_name, isApp),
      () => html`
        <div class="pd-submit__btns">
          <div class="pd-submit__submit_btn_wrapper">${submit_btn}</div>

          ${UtilS.htmlIf2(
            !disabled,
            () =>
              html`${
                  /* 강제 무료배송 상품일 경우 */
                  is_only_buy_now
                    ? ''
                    : html` <button
                        style="display: none;"
                        class="pd-submit__btn pd-submit__btn--cart"
                        type="button"
                        data-action="cart"
                      >
                        ${btn_text}
                      </button>`
                }
                <button
                  style="display: none; background: ${MShopCoreConstantS.colors
                    .blue}; color: ${MShopCoreConstantS.colors.white};"
                  class="pd-submit__btn"
                  type="button"
                  data-action="checkout"
                >
                  ${product_detail.funding
                    ? ET('preorder::cta_participate_in_the_challenge')
                    : ET('product_detail::cta::buy_now')}
                </button>`,
          )}
        </div>
      `,
    )}
  </div>`;
};

// 장바구니 버튼
export const makeFormSubmitBtn = (props) => {
  if (UtilS.isNessApp()) {
    return makeFormSubmitBtnNess(props);
  }

  const {
    is_mobile,
    product_detail,
    sales_info,
    isApp,
    store /* login_user */,
    is_sold_out_all_size,
    is_login,
  } = props;
  const {
    funding,
    _: { stores_product },
  } = product_detail;
  const {
    _: { stores_products_token_gates },
  } = stores_product;

  const disabled = checkIsDisabled({
    isApp,
    product_detail,
    store,
    sales_info,
    is_sold_out_all_size,
  });

  const status = checkProductSaleStatus({
    isApp,
    product_detail,
    store,
    sales_info,
    is_sold_out_all_size,
  });

  const product_sale_status = getProductSaleStatus({ disabled, product_detail, status });

  const btn_text = {
    ABLE: ET('product_detail::cta::cart'),
    NOT_APPROVE: ET('product_detail::cta::not_approve'),
    SOLD_OUT: isNil(funding) ? ET('cta::sold_out') : ET('preorder::cta_challenge_end'),
    COMING_SOON: ET('product_detail::cta::coming_soon'),
    END_SALE: isNil(funding) ? ET('product_detail::cta::end_sale') : ET('preorder::cta_challenge_end'),
    ONLY_PC: ET('cta::dtg'),
    PURCHASED_DTG: ET('product_detail::cta::purchased_dtg'),
  }[status];

  /*
   * 바로 구매하기 버튼만 등장하는 경우
   * 1. stores_products 의 only_buy_now 가 true
   * 2. 마플샵배송이 무료 배송인경우 (2177)
   * 3. 셀러상품인데 해외 배송인경우
   * */
  const is_only_buy_now =
    product_detail._.stores_product.only_buy_now ||
    product_detail.stores_delivery_company.id == PBStoresDeliveryCompanyConstantS.FREE_ID ||
    (T.lang != 'kr' &&
      product_detail.stores_delivery_company.lang != 'kr' &&
      DeliveryTypeS.isSeller(product_detail.stores_delivery_company.delivery_type_id));

  // TODO: NFT 버튼도 리팩토링 @blan22
  if (stores_products_token_gates.length) {
    if (is_mobile) {
      return `${makeNotiHtml({ ...props, product_sale_status })}${MShopAppTokenGateStoresProductTmplS.mobileSubmitTokenGate(
        {
          btn_text,
          is_login,
          creator_summary: props?.creator_summary,
        },
      )}`;
    } else {
      return `${makeNotiHtml({ ...props, product_sale_status })}${MShopAppTokenGateStoresProductTmplS.pcSubmitTokenGate(
        {
          stores_products_token_gates,
          btn_text,
        },
      )}`;
    }
  } else {
    if (is_mobile) {
      return mobileSubmit({
        props,
        btn_text,
        status,
        disabled,
        is_only_buy_now,
        isApp,
        is_login,
        product_sale_status,
      });
    } else {
      return pcSubmit({ props, btn_text, status, disabled, is_only_buy_now, is_mobile, product_sale_status });
    }
  }
};
